import { FormEvent, memo, useCallback, useMemo } from 'react';
import classnames from 'classnames';
import { SpecialStatusSelector } from '@/components/ui/CreditTracker/util/constants';
import Selector from '@/components/ui/Form/Selector';
import Icon from '@/components/ui/Icon';

interface ExperienceLevelSelectorProps {
  statuses: SpecialStatusSelector[];
  selectorSize?: 'small' | 'medium' | 'large';
  onChange?: (status: SpecialStatusSelector) => void;
  showError?: boolean;
}

const ExperienceLevelSelector: React.FC<ExperienceLevelSelectorProps> = memo(
  ({ statuses, selectorSize = 'large', onChange, showError = false }) => {
    const handleClick = useCallback(
      (status: SpecialStatusSelector) => {
        if (onChange) {
          onChange(status);
        }
      },
      [onChange]
    );

    const selectors = useMemo(() => {
      return statuses?.map((status, i) => {
        const classes = classnames({
          'mt-5': i != 0
        });

        return (
          <Selector
            key={status.text?.replaceAll(' ', '_')}
            size={selectorSize}
            label={status.text}
            value={status.value}
            className={classes}
            checked={status.value.toString()?.toLowerCase() === 'true'}
            onClick={(_: FormEvent<HTMLButtonElement>) => handleClick(status)}
          />
        );
      });
    }, [handleClick, selectorSize, statuses]);

    return (
      <div>
        {selectors}
        {showError && (
          <div className="label my-8 flex items-center text-red">
            <Icon name="alert" size="small" className="mr-1 inline-flex" />
            Please select an option to continue
          </div>
        )}
      </div>
    );
  }
);

ExperienceLevelSelector.displayName = 'ExperienceLevelSelector';
export default ExperienceLevelSelector;
